import { Department, IDepartment } from '../department';
import {
  GL_ACCOUNT_MAX_CODE_LENGTH,
  GL_ACCOUNT_MAX_NAME_LENGTH,
  IGLAccount,
  IGLAccountData
} from './accounting.types';

export class GLAccount implements IGLAccount {
  readonly id?: number;
  readonly code: string;
  readonly name: string;
  readonly departments: (IDepartment | number)[] = [];

  constructor(data: IGLAccountData) {
    if (data.id) {
      this.id = data.id;
    }

    this.code = data.code;
    this.name = data.name;

    if (data.departments) {
      this.departments = data.departments.map(department => {
        return typeof department === 'number'
          ? department
          : new Department(department);
      });
    }
  }

  validate(): boolean {
    // ensure department code is valid
    if (!this.code || this.code.length > GL_ACCOUNT_MAX_CODE_LENGTH) {
      return false;
    }

    // ensure department name is valid
    if (!this.name || this.name.length > GL_ACCOUNT_MAX_NAME_LENGTH) {
      return false;
    }

    return true;
  }
}
